export default __webpack_public_path__ + "static/media/logoMobilecopy.c9774bab.png";